module.exports = __webpack_public_path__ + "assets/img/00174.81c44c2e.png";